import { Dialog } from 'ui/shared/containers';
import { ThemePropertiesForm } from '../themePropertiesForm/ThemePropertiesForm';
import { Theme } from 'shared/models';

export type Props = {
    visible: boolean;
    isNew: boolean;
    isSubmitting: boolean;
    displayName?: string;
    width?: number;
    height?: number;
    requirements?: Theme['requirements'];
    buildingId: string;
    options?: Theme['options'];
    onAccept: ({ displayName, deviceType, width, height, uploaded, requirements, options }: any) => void;
    onCancel: () => void;
};

export const ThemePropertiesDialog = ({ visible, ...props }: Props) =>
    <Dialog
        id={ props.isNew ? 'new-theme-dialog' : 'edit-theme-dialog' }
        visible={ visible }
        titleKey={ props.isNew ? 'THEMES.NEW_DIALOG.TITLE' : 'THEMES.EDIT_DIALOG.TITLE' }
    >
        <ThemePropertiesForm { ...props }/>
    </Dialog>
;
